import { NgFor } from '@angular/common';
import { Component, ElementRef, Input, OnInit, QueryList, Renderer2, ViewChildren, inject } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { RoomFilter } from '@core/models/domains/room';
import { HotelInfoUiService } from '../../services/hotel-info-ui.service';
import { SwiperService } from '@shared/services/swiper-config.service';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'iho-pdp-rooms-filters',
  standalone: true,
  imports: [
    NgFor,
    MatRippleModule,
    SharedModule
  ],
  templateUrl: './pdp-rooms-filters.component.html',
  styleUrls: ['./pdp-rooms-filters.component.scss'],
})
export class PdpRoomsFiltersComponent implements OnInit{
  filtersArray!: Array<any>
  configSwiperEachFilter:any;
  
  renderer = inject(Renderer2)
  pdpUiService = inject(HotelInfoUiService)
  constructor(private swiperService: SwiperService) {

  }
  @ViewChildren('filterBtn') buttons!: QueryList<ElementRef>

  @Input() set dataSource(ds: Array<RoomFilter>) {
    if(ds) {
      this.filtersArray = ds.map(item => ({
        ...item,
        isActive: false
      }))
    }
  }
  
  @Input() set resetFilters(e: boolean) {
    this.resetFiltersSignal() //for setting all filters deActive
    this._resetFilters = e
  } 
  _resetFilters = false

  activeFilters: Array<number> = []
  activeFiltersNames: Array<string> = []
  ngOnInit(): void {
    let config = {
    
     slide: "auto",
      pagination: {
        enabled: false,
        clickable: false,
      },
    }
    this.configSwiperEachFilter = this.swiperService.SwiperConfig(config);

  }
  toggleFilter(filterId: number, filterName: string) {
    this.activeFilters = this.pdpUiService.activeRoomFiltersIds()
    this.activeFiltersNames = this.pdpUiService.activeRoomFiltersNames()
    //const clickedFilter = this.buttons.toArray().find((each) => each.nativeElement.)
    this.filtersArray?.forEach(
      (item: { id: number, name: string, isActive: boolean }) => {

      if(item.id === filterId) {
        item.isActive = !item.isActive
        const foundItem = this.activeFilters.find((eachFilterId: number) => eachFilterId === filterId)
        if(foundItem) {
          this.pdpUiService.activeRoomFiltersIds.update(() => [...this.activeFilters.filter((each) => each !== filterId)])
          this.pdpUiService.activeRoomFiltersNames.update(() => [...this.activeFiltersNames.filter((each) => each !== filterName)])
        }
        else {
          this.pdpUiService.activeRoomFiltersIds.update(() => [...this.activeFilters, filterId])
          this.pdpUiService.activeRoomFiltersNames.update(() => [...this.activeFiltersNames, filterName])
        } 
      }
    })
  }

  resetFiltersSignal() {
    if (this.filtersArray?.length) {
      this.filtersArray = this.filtersArray.map(item => ({
        ...item,
        isActive: false
      }))
    }
    else {
      this.filtersArray = []
    }
    this.pdpUiService.activeRoomFiltersIds.set([])
    this.pdpUiService.activeRoomFiltersNames.set([])
  }
 
}
